import { api } from "../../config/api";
import { createAsyncThunk } from "@reduxjs/toolkit";

// Public routes
export const getAllProducerPacks = createAsyncThunk(
  "producerPack/getAllProducerPacks",
  async ({ page = 1, limit = 10, search = "", category, daw, plugin, tag, sortBy = "publishedDate", sortOrder = "desc" }) => {
    const response = await api.get("/producer-packs", {
      params: {
        page,
        limit,
        search,
        category,
        daw,
        plugin,
        tag,
        sortBy,
        sortOrder,
      },
    });
    return response.data;
  }
);

export const searchProducerPacks = createAsyncThunk(
  "producerPack/searchProducerPacks",
  async ({ q, page = 1, limit = 10 }) => {
    const response = await api.get("/producer-packs/search", {
      params: {
        q,
        page,
        limit,
      },
    });
    return response.data;
  }
);

export const getLatestProducerPacks = createAsyncThunk(
  "producerPack/getLatestProducerPacks",
  async () => {
    const response = await api.get("/producer-packs/latest");
    return response.data;
  }
);

export const getLatestProducerPacksLanding = createAsyncThunk(
  "producerPack/getLatestProducerPacksLanding",
  async () => {
    const response = await api.get("/producer-packs/latest/landing");
    return response.data;
  }
);

export const getAvailableDAWs = createAsyncThunk(
  "producerPack/getAvailableDAWs",
  async () => {
    const response = await api.get("/producer-packs/filters/daws");
    return response.data;
  }
);

export const getAvailablePlugins = createAsyncThunk(
  "producerPack/getAvailablePlugins",
  async () => {
    const response = await api.get("/producer-packs/filters/plugins");
    return response.data;
  }
);

export const getProducerPacksByCategory = createAsyncThunk(
  "producerPack/getProducerPacksByCategory",
  async ({ categoryId, page = 1, limit = 10, sortBy = "publishedDate", sortOrder = "desc" }) => {
    const response = await api.get(`/producer-packs/category/${categoryId}`, {
      params: {
        page,
        limit,
        sortBy,
        sortOrder,
      },
    });
    return response.data;
  }
);

export const getProducerPackByPackId = createAsyncThunk(
  "producerPack/getProducerPackByPackId",
  async ({ id }) => {
    const response = await api.get(`/producer-packs/packId/${id}`);
    return response.data;
  }
);

// Admin routes
export const getAllProducerPacksForTable = createAsyncThunk(
  "producerPack/getAllProducerPacksForTable",
  async ({ token, page = 1, limit = 10, search = "" }) => {
    const response = await api.get("/producer-packs/admin/table", {
      token,
      params: {
        page,
        limit,
        search,
      },
    });
    return response.data;
  }
);

export const getSpecificProducerPack = createAsyncThunk(
  "producerPack/getSpecificProducerPack",
  async ({ token, id }) => {
    const response = await api.get(`/producer-packs/admin/${id}`, { token });
    return response.data;
  }
);

export const createProducerPack = createAsyncThunk(
  "producerPack/createProducerPack",
  async ({ token, payload }) => {
    const response = await api.post(
      "/producer-packs",
      { payload },
      { token }
    );
    return response.data;
  }
);

export const updateProducerPack = createAsyncThunk(
  "producerPack/updateProducerPack",
  async ({ token, id, payload }) => {
    const response = await api.put(
      `/producer-packs/${id}`,
      { payload },
      { token }
    );
    return response.data;
  }
);

export const toggleProducerPackStatus = createAsyncThunk(
  "producerPack/toggleProducerPackStatus",
  async ({ token, id }) => {
    const response = await api.patch(
      `/producer-packs/${id}/toggle-status`,
      {},
      { token }
    );
    return response.data;
  }
);

export const deleteProducerPack = createAsyncThunk(
  "producerPack/deleteProducerPack",
  async ({ token, id }) => {
    const response = await api.delete(`/producer-packs/${id}`, { token });
    return response.data;
  }
);
